import type { CustomerAccountsTranslations } from './types'

/**
 * Arabic translations for CustomerAccounts domain
 */
export const arTranslations: CustomerAccountsTranslations = {
  // Page/Section level
  title: "حسابات العملاء",
  subtitle: "إدارة الحسابات المالية للعملاء وحدود الائتمان",

  // Actions
  addCustomerAccount: "إضافة حساب عميل",
  editCustomerAccount: "تعديل حساب العميل",
  deleteCustomerAccount: "حذف حساب العميل",

  // Search and filters
  searchPlaceholder: "البحث في حسابات العملاء...",
  noItemsFound: "لم يتم العثور على حسابات عملاء",
  noItemsDescription: "لم تقم بإضافة أي حسابات عملاء بعد.",
  addFirst: "أضف أول حساب عميل",

  // Form section
  form: {
    name: "اسم الحساب",
    namePlaceholder: "أدخل اسم الحساب",
    status: "الحالة",
    validation: {
      nameRequired: "اسم الحساب مطلوب",
    }
  },

  // Status
  status: {
    active: "نشط",
    inactive: "غير نشط",
    suspended: "معلّق",
    blocked: "محظور",
  },

  actions: {
    viewDetails: "عرض التفاصيل",
    activate: "تفعيل",
    suspend: "تعليق",
    block: "حظر",
    adjustCreditLimit: "تعديل حد الائتمان",
  },

  // Messages
  messages: {
    createSuccess: "تم إنشاء حساب العميل بنجاح",
    updateSuccess: "تم تحديث حساب العميل بنجاح",
    deleteSuccess: "تم حذف حساب العميل بنجاح",
    deleteConfirm: "هل أنت متأكد من حذف هذا الحساب؟",
  },

  stats: {
    totalAccounts: "إجمالي الحسابات",
    totalCreditLimit: "إجمالي الائتمان",
    totalOutstanding: "الرصيد المستحق",
    totalOverdue: "المتأخرات",
    accountsLabel: "حسابات",
  },

  filters: {
    searchAccounts: "البحث بالحساب أو العميل أو رقم BP SAP...",
    status: "الحالة",
    paymentTerms: "شروط الدفع",
    channel: "القناة",
  },

  channel: {
    b2b: "الأعمال",
    ecommerce: "التجارة الإلكترونية",
  },

  paymentTerms: {
    cod: "الدفع عند التسليم",
    prepaid: "مدفوع مقدمًا",
    net_7: "صافي 7",
    net_15: "صافي 15",
    net_30: "صافي 30",
    net_60: "صافي 60",
    net_90: "صافي 90",
    custom: "مخصص",
  },

  labels: {
    creditLimit: "حد الائتمان",
    currentBalance: "الرصيد",
    availableCredit: "المتاح",
    overdue: "متأخر",
    utilization: "استخدام الائتمان",
    lastPayment: "آخر دفعة",
    noPayments: "لا توجد دفعات حتى الآن",
    accountDetails: "تفاصيل الحساب",
    accountInfo: "معلومات الحساب",
    tenant: "العميل",
    paymentTerms: "شروط الدفع",
    vibanNumber: "رقم VIBAN",
    creditManagement: "إدارة الائتمان",
    newCreditLimit: "حد ائتمان جديد",
    hasOverdue: "متأخر",
    notes: "ملاحظات",
    sapBpNumber: "رقم BP SAP",
  },

  // Table headers
  table: {
    account: "الحساب",
    tenant: "العميل",
    channel: "القناة",
    paymentTerms: "شروط الدفع",
    creditLimit: "حد الائتمان",
    currentBalance: "الرصيد",
    overdue: "المتأخر",
    actions: "الإجراءات",
    name: "الاسم",
    status: "الحالة",
  },

  view: {
    table: "عرض الجدول",
    cards: "عرض البطاقات",
  },

  empty: {
    noAccountsFound: "لم يتم العثور على حسابات",
  },

  cityAccess: {
    title: "صلاحيات المدن",
    description: "حدد المدن التي يمكن لهذا الحساب إنشاء طلبات إليها. اتركها فارغة للسماح بكل المدن.",
    noCitiesAvailable: "لا توجد مدن نشطة متاحة",
    allCitiesAllowed: "جميع المدن مسموحة",
  },

  // Region access control
  regionAccess: 'صلاحيات المناطق',
  regionAccessDescription: 'حدد المناطق التي يمكن لهذا الحساب التوصيل إليها. اتركه فارغًا للسماح بجميع المناطق.',
  noRegionsAvailable: 'لا توجد مناطق نشطة متاحة',
  allRegionsAllowed: 'جميع المناطق مسموحة',
}
